import { atom } from 'jotai'

import { Setup2faResponse } from '@/types/generated/common/auth'

export const twoFactorSetupAtom = atom<Omit<Setup2faResponse, 'success' | 'errorMessage'> | null>(
  null
)
